import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
export * from 'axios'

export type RequestOptions = {
  /** 接口数据是否进行签名加解密处理
   * @default false
   */
  signature?: boolean | 'decrypted'

  /**
   * 是否屏蔽统一的接口的错误处理
   * @default false
   */
  disableErrorCodeResponseHandler?: boolean
}

export interface HCAxiosRequestConfig<D = any> extends AxiosRequestConfig<D> {
  options?: RequestOptions
}

export interface HCAxiosInstance extends AxiosInstance {
  get<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: HCAxiosRequestConfig<D>): Promise<R>
  post<T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: HCAxiosRequestConfig<D>): Promise<R>
  put<T = any, R = AxiosResponse<T>, D = any>(url: string, data?: D, config?: HCAxiosRequestConfig<D>): Promise<R>
  delete<T = any, R = AxiosResponse<T>, D = any>(url: string, config?: HCAxiosRequestConfig<D>): Promise<R>
}

const hcAxios: HCAxiosInstance = axios.create()

export default hcAxios
